// src/components/Topbar.js

import React, { useState } from 'react';
//import { FaUserCircle, FaCoins } from 'react-icons/fa';
import { FaUserCircle } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom'; // Importa Link
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './Topbar.css';

const Topbar = ({ userInfo, user }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/');
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <div className="topbar">
      <Link to="/dashboard" className="dashboard-link">
        Dashboard
        </Link>
      <div className="topbar-right">
        {/* <div className="credits">
          <FaCoins className="icon" />
          <span>{userInfo.trialCredits}</span>
        </div> */}
        <div className="profile-menu">
          <FaUserCircle className="profile-icon" onClick={toggleDropdown} />
          {dropdownOpen && (
            <div className="dropdown-menu">
              <p>
                {userInfo.firstName} {userInfo.lastName}
              </p>
              <p>Email: {user.email}</p>
              <p>Ruolo: {userInfo.role}</p>
              {(userInfo.role === 'studente' || userInfo.role === 'istituzione') && (
                <p>Istituzione: {userInfo.institution}</p>
              )}
              <button onClick={handleLogout}>Logout</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;
